import { render, staticRenderFns } from "./github.vue?vue&type=template&id=6de4c978"
import script from "./github.vue?vue&type=script&lang=js"
export * from "./github.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports